import { KeyOutlined } from "@ant-design/icons";
import { Button, Card, Divider, Input, Typography, AutoComplete } from "antd";
import React, { useState, useEffect } from "react";
import { handleLoginAsUserEmail } from "../../admin/users";
import { encodeAuthString } from "../../../helper/encode";
import store from "../../../redux/store";
import { useSelector } from "react-redux";
import { selectUserDoc } from "../../../redux/features/userSlice";
import { getUserToken } from "../../../helper/attribute";
import OtherSuperAdminSettings from "../../super-admin/SuperAdminSectionPages/Other";

const ConsultantDashboard = () => {
  const [email, setEmail] = useState("");
  const [emailOptions, setEmailOptions] = useState([]);
  const user = useSelector(selectUserDoc);

  useEffect(() => {
    // Load saved email suggestions from localStorage
    loadSavedEmails();
  }, []);

  const loadSavedEmails = () => {
    const savedEmails = localStorage.getItem("consultant_emails_dashboard_cache");
    if (savedEmails) {
      const parsedEmails = JSON.parse(savedEmails);
      updateEmailOptions(parsedEmails);
    }
  };

  const updateEmailOptions = (emailsArray) => {
    setEmailOptions(emailsArray.map(email => ({
      value: email,
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {email}
          <span 
            onClick={(e) => {
              e.stopPropagation();
              deleteEmail(email);
            }}
            style={{ color: 'red', cursor: 'pointer' }}
          >
            ✕
          </span>
        </div>
      )
    })));
  };

  const handleInputChange = (value) => {
    setEmail(value);
  };

  const handleSearch = (searchText) => {
    const savedEmails = localStorage.getItem("consultant_emails_dashboard_cache");
    if (savedEmails) {
      const parsedEmails = JSON.parse(savedEmails);
      const filteredEmails = parsedEmails.filter(email => 
        email.toLowerCase().includes(searchText.toLowerCase())
      );
      updateEmailOptions(filteredEmails);
    }
  };

  const saveEmailToLocalStorage = (emailToSave) => {
    if (!emailToSave) return;
    
    const savedEmails = localStorage.getItem("consultant_emails_dashboard_cache");
    let emailsArray = savedEmails ? JSON.parse(savedEmails) : [];
    
    // Only add if it doesn't already exist
    if (!emailsArray.includes(emailToSave)) {
      emailsArray.push(emailToSave);
      localStorage.setItem("consultant_emails_dashboard_cache", JSON.stringify(emailsArray));
      updateEmailOptions(emailsArray);
    }
  };

  const deleteEmail = (emailToDelete) => {
    const savedEmails = localStorage.getItem("consultant_emails_dashboard_cache");
    if (savedEmails) {
      const emailsArray = JSON.parse(savedEmails);
      const updatedEmails = emailsArray.filter(email => email !== emailToDelete);
      localStorage.setItem("consultant_emails_dashboard_cache", JSON.stringify(updatedEmails));
      updateEmailOptions(updatedEmails);
    }
  };

  return (
    <div>
      <Typography.Title level={4}>Consultant's dashboard</Typography.Title>

      <Divider />
      <Typography.Title level={2}>
        Welcome {user.firstName} {user.lastName}
      </Typography.Title>

      <Card title="Login as user">
        <AutoComplete
          options={emailOptions}
          style={{ width: "500px" }}
          value={email}
          onChange={handleInputChange}
          onSearch={handleSearch}
          placeholder="User's email (case sensitive)"
          filterOption={false} // Disable default filtering
        />
        <Button
          icon={<KeyOutlined />}
          onClick={async () => {
            const token = await getUserToken();
            localStorage.setItem("consultant_token", token);
            saveEmailToLocalStorage(email);
            await handleLoginAsUserEmail(email, "/consultant_user_verification?auth_key=" + store.getState().user.doc.id);
          }}
          type="primary"
          style={{ marginTop: "10px" }}
        >
          Login
        </Button>
      </Card>
      
      <Card title="Fetch users">
        <OtherSuperAdminSettings isConsultant={true} />
      </Card>
    </div>
  );
};

export default ConsultantDashboard;
